import React, { useEffect, useRef, useState } from 'react';

import {
  Container,
  FormCheckbox,
  FormCheckboxes,
  FormikWrapper,
  FormSelect,
  FormTextField,
  Icon,
  TableRender,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';
import { ButtonWrapper, FormRange } from '../../components';

const spacings = [2, 4, 8, 12, 16, 20, 24, 32, 36, 40, 48, 56, 64, 72, 96, 120, 144, 192, 256, 384];

const DesignSystem: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);

  const [materialIconNames, setMaterialIconNames] = useState<string[]>([]);
  const [customIconNames, setCustomIconNames] = useState<string[]>([]);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const style = window.getComputedStyle(ref.current);
    const materialIcons = style.getPropertyValue('--material-icon-names');
    const customIcons = style.getPropertyValue('--custom-icon-names');

    setMaterialIconNames(materialIcons.split(',').map((icon) => icon.trim()));
    setCustomIconNames(customIcons.split(',').map((icon) => icon.trim()));
  }, []);

  return (
    <article className="DesignSystem" ref={ref}>
      <div className="Paragraph">
        <Container>
          <h1>Design System</h1>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h2>Spacers</h2>
          <ol className="DesignSystem__spacers">
            {spacings.map((spacing, index) => {
              const className = `DesignSystem__spacers__${index + 1}`;
              const amount = `${spacing}px`;

              return (
                <li className={className}>
                  <span className={`${className}__amount`}>{amount}</span>
                  <span className={`${className}__block`} />
                </li>
              );
            })}
          </ol>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h2>Headings</h2>
          <div>
            <h1> h1 The quick brown fox jumps over the lazy dog</h1>
            <h2> h2 The quick brown fox jumps over the lazy dog</h2>
            <h3> h3 The quick brown fox jumps over the lazy dog</h3>
            <h4> h4 The quick brown fox jumps over the lazy dog</h4>
            <h5> h5 The quick brown fox jumps over the lazy dog</h5>
            <h6> h6 The quick brown fox jumps over the lazy dog</h6>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h2>Text</h2>
          <div className="body--large">
            <p>Body--large: The quick brown fox jumps over the lazy dog</p>
          </div>
          <div className="body--regular">
            <p>Body--regular: The quick brown fox jumps over the lazy dog</p>
          </div>
          <div className="body--small">
            <p>Body--small: The quick brown fox jumps over the lazy dog</p>
          </div>
          <div className="body--tiny">
            <p>Body--tiny: The quick brown fox jumps over the lazy dog</p>
          </div>
          <div className="quote">
            <p>Quote: The quick brown fox jumps over the lazy dog</p>
          </div>
          <div className="link--large">
            <p>Link--large: The quick brown fox jumps over the lazy dog</p>
          </div>
          <div className="link--regular">
            <p>Link--regular: The quick brown fox jumps over the lazy dog</p>
          </div>
          <div className="link--small">
            <p>Link--small: The quick brown fox jumps over the lazy dog</p>
          </div>
          <div className="caption">
            <p>Caption: The quick brown fox jumps over the lazy dog</p>
          </div>
          <div className="label--large">
            <p>Label--large: The quick brown fox jumps over the lazy dog</p>
          </div>
          <div className="label--regular">
            <p>Label--regular: The quick brown fox jumps over the lazy dog</p>
          </div>
          <div className="label--small">
            <p>Label--small: The quick brown fox jumps over the lazy dog</p>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h2>Lists</h2>
          <div>
            <ul>
              <li>The quick brown fox jumps over the lazy dog</li>
              <li>The quick brown fox jumps over another lazy dog</li>
              <li>The quick brown fox jumps over a third lazy dog</li>
            </ul>
            <p>Some more text</p>

            <ol>
              <li>The quick brown fox jumps over the lazy dog once</li>
              <li>The quick brown fox jumps over the lazy dog twice</li>
              <li>The quick brown fox jumps over the lazy dog thrice</li>
            </ol>
            <p>Some more text</p>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h2>Table</h2>
          <TableRender
            element={(
              <table>
                <thead>
                  {' '}
                  <tr>
                    {' '}
                    <th>City</th> <th>Country</th> <th>Population</th>{' '}
                    <th>Area (sq km)</th> <th>Cost of Living</th>{' '}
                    <th>Avg Temperature (°C)</th> <th>Happines Rate</th>{' '}
                  </tr>
                </thead>
                <tbody>
                  {' '}
                  <tr>
                    {' '}
                    <td>New York</td> <td>USA</td> <td>8,398,748</td> <td>789</td>{' '}
                    <td>High</td> <td>12.5</td> <td>Medium</td>{' '}
                  </tr>{' '}
                  <tr>
                    {' '}
                    <td>London</td> <td>UK</td> <td>8,136,000</td> <td>1,572</td>{' '}
                    <td>High</td> <td>10.2</td> <td>Low</td>{' '}
                  </tr>{' '}
                  <tr>
                    {' '}
                    <td>Tokyo</td> <td>Japan</td> <td>13,515,271</td> <td>2,194</td>{' '}
                    <td>Very High</td> <td>16.9</td> <td>Low</td>{' '}
                  </tr>{' '}
                  <tr>
                    {' '}
                    <td>Paris</td> <td>France</td> <td>2,140,526</td> <td>105</td>{' '}
                    <td>High</td> <td>11.4</td> <td>Medium</td>{' '}
                  </tr>{' '}
                  <tr>
                    {' '}
                    <td>Beijing</td> <td>China</td> <td>21,542,000</td> <td>16,410</td>{' '}
                    <td>Moderate</td> <td>12.8</td> <td>Medium</td>{' '}
                  </tr>{' '}
                  <tr>
                    {' '}
                    <td>Rome</td> <td>Italy</td> <td>2,873,494</td> <td>1,285</td>{' '}
                    <td>High</td> <td>15.2</td> <td>Medium</td>{' '}
                  </tr>{' '}
                  <tr>
                    {' '}
                    <td>Cairo</td> <td>Egypt</td> <td>9,500,000</td> <td>606</td>{' '}
                    <td>Low</td> <td>24.5</td> <td>High</td>{' '}
                  </tr>{' '}
                  <tr>
                    {' '}
                    <td>Sydney</td> <td>Australia</td> <td>5,312,163</td> <td>1,637</td>{' '}
                    <td>High</td> <td>18.9</td> <td>Low</td>{' '}
                  </tr>{' '}
                  <tr>
                    {' '}
                    <td>Mumbai</td> <td>India</td> <td>20,668,076</td> <td>603</td>{' '}
                    <td>Low</td> <td>27.2</td> <td>High</td>{' '}
                  </tr>{' '}
                  <tr>
                    {' '}
                    <td>Rio de Janeiro</td> <td>Brazil</td> <td>6,747,815</td>{' '}
                    <td>1,221</td> <td>Moderate</td> <td>23.8</td> <td>High</td>{' '}
                  </tr>
                </tbody>
              </table>
            )}
            mobileCardsBreakpoint={768}
          />
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h2>Primary colors</h2>
          <ol className="DesignSystem__colors">
            {Array.from(Array(9).keys()).map((index) => (
              <li className={`DesignSystem__colors--primary__${index + 1}`}>{(index + 1) * 100}</li>
            ))}
          </ol>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h2>Secondary colors</h2>
          <ol className="DesignSystem__colors">
            {Array.from(Array(9).keys()).map((index) => (
              <li className={`DesignSystem__colors--secondary__${index + 1}`}>{(index + 1) * 100}</li>
            ))}
          </ol>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h2>Tertiary colors</h2>
          <h3>Alpha</h3>
          <ol className="DesignSystem__colors">
            {Array.from(Array(9).keys()).map((index) => (
              <li className={`DesignSystem__colors--tertiary--alpha__${index + 1}`}>{(index + 1) * 100}</li>
            ))}
          </ol>

          <h3>Beta</h3>
          <ol className="DesignSystem__colors">
            {Array.from(Array(9).keys()).map((index) => (
              <li className={`DesignSystem__colors--tertiary--beta__${index + 1}`}>{(index + 1) * 100}</li>
            ))}
          </ol>

          <h3>Charlie</h3>
          <ol className="DesignSystem__colors">
            {Array.from(Array(9).keys()).map((index) => (
              <li className={`DesignSystem__colors--tertiary--charlie__${index + 1}`}>{(index + 1) * 100}</li>
            ))}
          </ol>

          <h3>Delta</h3>
          <ol className="DesignSystem__colors">
            {Array.from(Array(9).keys()).map((index) => (
              <li className={`DesignSystem__colors--tertiary--delta__${index + 1}`}>{(index + 1) * 100}</li>
            ))}
          </ol>

          <h3>Echo</h3>
          <ol className="DesignSystem__colors">
            {Array.from(Array(9).keys()).map((index) => (
              <li className={`DesignSystem__colors--tertiary--echo__${index + 1}`}>{(index + 1) * 100}</li>
            ))}
          </ol>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h2>Neutral colors</h2>
          <ol className="DesignSystem__colors">
            {Array.from(Array(9).keys()).map((index) => (
              <li className={`DesignSystem__colors--neutral__${index + 1}`}>{(index + 1) * 100}</li>
            ))}
          </ol>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h2>System colors</h2>
          <h3>Error</h3>
          <ol className="DesignSystem__colors">
            {Array.from(Array(9).keys()).map((index) => (
              <li className={`DesignSystem__colors--system--error__${index + 1}`}>{(index + 1) * 100}</li>
            ))}
          </ol>

          <h3>Warning</h3>
          <ol className="DesignSystem__colors">
            {Array.from(Array(9).keys()).map((index) => (
              <li className={`DesignSystem__colors--system--warning__${index + 1}`}>{(index + 1) * 100}</li>
            ))}
          </ol>

          <h3>Success</h3>
          <ol className="DesignSystem__colors">
            {Array.from(Array(9).keys()).map((index) => (
              <li className={`DesignSystem__colors--system--success__${index + 1}`}>{(index + 1) * 100}</li>
            ))}
          </ol>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h2>Grid systeem</h2>
        </Container>

        <Container small className="DesignSystem__grid">
          <h3>Small</h3>
          <div className="row">
            {Array.from(Array(12).keys()).map((index) => (
              <div className="col-1"><div>{index + 1}</div></div>
            ))}
          </div>

          <div className="row">
            <div className="col-4"><div>1</div></div>
            <div className="col-4"><div>2</div></div>
            <div className="col-4"><div>3</div></div>
          </div>

          <div className="row">
            <div className="col-12"><div>1</div></div>
          </div>
        </Container>

        <Container medium className="DesignSystem__grid">
          <h3>Medium</h3>
          <div className="row">
            {Array.from(Array(12).keys()).map((index) => (
              <div className="col-1"><div>{index + 1}</div></div>
            ))}
          </div>

          <div className="row">
            <div className="col-4"><div>1</div></div>
            <div className="col-4"><div>2</div></div>
            <div className="col-4"><div>3</div></div>
          </div>

          <div className="row">
            <div className="col-12"><div>1</div></div>
          </div>
        </Container>

        <Container className="DesignSystem__grid">
          <h3>Normal</h3>
          <div className="row">
            {Array.from(Array(12).keys()).map((index) => (
              <div className="col-1"><div>{index + 1}</div></div>
            ))}
          </div>

          <div className="row">
            <div className="col-4"><div>1</div></div>
            <div className="col-4"><div>2</div></div>
            <div className="col-4"><div>3</div></div>
          </div>

          <div className="row">
            <div className="col-12"><div>1</div></div>
          </div>
        </Container>

        <Container large className="DesignSystem__grid">
          <h3>Large</h3>
          <div className="row">
            {Array.from(Array(12).keys()).map((index) => (
              <div className="col-1"><div>{index + 1}</div></div>
            ))}
          </div>

          <div className="row">
            <div className="col-4"><div>1</div></div>
            <div className="col-4"><div>2</div></div>
            <div className="col-4"><div>3</div></div>
          </div>

          <div className="row">
            <div className="col-12"><div>1</div></div>
          </div>
        </Container>

        <Container fluid className="DesignSystem__grid">
          <h3>Fluid</h3>
          <div className="row">
            {Array.from(Array(12).keys()).map((index) => (
              <div className="col-1"><div>{index + 1}</div></div>
            ))}
          </div>

          <div className="row">
            <div className="col-4"><div>1</div></div>
            <div className="col-4"><div>2</div></div>
            <div className="col-4"><div>3</div></div>
          </div>

          <div className="row">
            <div className="col-12"><div>1</div></div>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h2>Buttons</h2>
          <h3>Primary</h3>
          <div className="DesignSystem__buttons">
            <ButtonWrapper>Button</ButtonWrapper>
            <ButtonWrapper iconName="arrow_forward">Button</ButtonWrapper>
            <ButtonWrapper iconName="arrow_back" iconPosition="left">Button</ButtonWrapper>
            <ButtonWrapper iconName="arrow_forward" disabled>Button</ButtonWrapper>
            <ButtonWrapper iconName="arrow_forward" variant="icon-only">Button</ButtonWrapper>
            <ButtonWrapper iconName="arrow_forward" variant="icon-only" disabled>Button</ButtonWrapper>
            <div className="DesignSystem__buttons__fake-button--primary">Fake button</div>
          </div>

          <h3>Primary inverted</h3>
          <div className="DesignSystem__buttons DesignSystem__buttons--inverted">
            <ButtonWrapper inverted>Button</ButtonWrapper>
            <ButtonWrapper inverted iconName="arrow_forward">Button</ButtonWrapper>
            <ButtonWrapper inverted iconName="arrow_back" iconPosition="left">Button</ButtonWrapper>
            <ButtonWrapper inverted iconName="arrow_forward" disabled>Button</ButtonWrapper>
            <ButtonWrapper inverted iconName="arrow_forward" variant="icon-only">Button</ButtonWrapper>
            <ButtonWrapper inverted iconName="arrow_forward" variant="icon-only" disabled>Button</ButtonWrapper>
            <div className="DesignSystem__buttons__fake-button--primary Button--inverted">Fake button</div>
          </div>

          <h3>Secondary</h3>
          <div className="DesignSystem__buttons">
            <ButtonWrapper type="secondary">Button</ButtonWrapper>
            <ButtonWrapper type="secondary" iconName="arrow_forward">Button</ButtonWrapper>
            <ButtonWrapper type="secondary" iconName="arrow_back" iconPosition="left">Button</ButtonWrapper>
            <ButtonWrapper type="secondary" iconName="arrow_forward" disabled>Button</ButtonWrapper>
            <ButtonWrapper type="secondary" iconName="arrow_forward" variant="icon-only">Button</ButtonWrapper>
            <ButtonWrapper type="secondary" iconName="arrow_forward" variant="icon-only" disabled>Button</ButtonWrapper>
            <div className="DesignSystem__buttons__fake-button--secondary">Fake button</div>
          </div>

          <h3>Secondary inverted</h3>
          <div className="DesignSystem__buttons DesignSystem__buttons--inverted">
            <ButtonWrapper inverted type="secondary">Button</ButtonWrapper>
            <ButtonWrapper inverted type="secondary" iconName="arrow_forward">Button</ButtonWrapper>
            <ButtonWrapper inverted type="secondary" iconName="arrow_back" iconPosition="left">Button</ButtonWrapper>
            <ButtonWrapper inverted type="secondary" iconName="arrow_forward" disabled>Button</ButtonWrapper>
            <ButtonWrapper inverted type="secondary" iconName="arrow_forward" variant="icon-only">Button</ButtonWrapper>
            <ButtonWrapper inverted type="secondary" iconName="arrow_forward" variant="icon-only" disabled>Button</ButtonWrapper>
            <div className="DesignSystem__buttons__fake-button--secondary Button--inverted">Fake button</div>
          </div>

          <h3>Textual</h3>
          <div className="DesignSystem__buttons">
            <ButtonWrapper type="textual">Button</ButtonWrapper>
            <ButtonWrapper type="textual" iconName="arrow_forward">Button</ButtonWrapper>
            <ButtonWrapper type="textual" iconName="arrow_back" iconPosition="left">Button</ButtonWrapper>
            <ButtonWrapper type="textual" iconName="arrow_forward" disabled>Button</ButtonWrapper>
            <ButtonWrapper type="textual" iconName="arrow_forward" variant="icon-only">Button</ButtonWrapper>
            <ButtonWrapper type="textual" iconName="arrow_forward" variant="icon-only" disabled>Button</ButtonWrapper>
            <div className="DesignSystem__buttons__fake-button--textual">Fake button</div>
          </div>

          <h3>Textual inverted</h3>
          <div className="DesignSystem__buttons DesignSystem__buttons--inverted">
            <ButtonWrapper inverted type="textual">Button</ButtonWrapper>
            <ButtonWrapper inverted type="textual" iconName="arrow_forward">Button</ButtonWrapper>
            <ButtonWrapper inverted type="textual" iconName="arrow_back" iconPosition="left">Button</ButtonWrapper>
            <ButtonWrapper inverted type="textual" iconName="arrow_forward" disabled>Button</ButtonWrapper>
            <ButtonWrapper inverted type="textual" iconName="arrow_forward" variant="icon-only">Button</ButtonWrapper>
            <ButtonWrapper inverted type="textual" iconName="arrow_forward" variant="icon-only" disabled>Button</ButtonWrapper>
            <div className="DesignSystem__buttons__fake-button--textual Button--inverted">Fake button</div>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <div className="DesignSystem__links">
            <h2>Links</h2>
            <WysiwygField html="<p>The quick brown fox jumps over the <a href=/>inline</a> lazy dog</p>" />
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h2>Form elements</h2>
          <div className="DesignSystem__forms">
            <FormikWrapper
              initialValues={{
                word: '',
                agreed_with_statement: false,
                poison: '',
                poison_2: [],
                poison_3: [],
              }}
            >
              <FormTextField
                title="Your favorite word"
                required
                description="This is a test input."
                placeholder="This is a placeholder"
                fieldName="word"
              />
              <FormSelect
                title="Pick your poison"
                required
                description="This is a test input."
                placeholder="Select a value..."
                fieldName="poison"
                options={{
                  beer: 'Beer',
                  wine: 'Wine',
                  rum: 'Rum',
                  whisky: 'Whisk(e)y',
                }}
                defaultValue="wine"
              />
              <FormSelect
                title="Pick your poisons"
                required
                description="This is a test input."
                placeholder="Select some values..."
                multiple
                fieldName="poison_3"
                options={{
                  beer: 'Beer',
                  wine: 'Wine',
                  rum: 'Rum',
                  whisky: 'Whisk(e)y',
                }}
                defaultValue="wine"
              />
              <FormCheckbox
                title="I agree with the statement"
                required
                description="By checking the above box, you agree with the statement."
                fieldName="agreed_with_statement"
              />
              <FormCheckboxes
                title="Pick your poison"
                required
                description="Please select your poison."
                fieldName="poison_2"
                options={{
                  beer: 'Beer',
                  wine: 'Wine',
                  rum: 'Rum',
                  whisky: 'Whisk(e)y',
                  __other__: 'Anders',
                }}
                otherLabel="Anders"
              />
              <FormRange
                title="Pick your range"
                required
                description="Please select your range."
                fieldName="range"
                min={0}
                max={100}
                step={5}
                defaultValue={50}
              />
            </FormikWrapper>
          </div>
        </Container>
      </div>

      <div className="Paragraph">
        <Container>
          <h2>Icons</h2>
          <h3>Material icons</h3>
          <ul className="DesignSystem__icons">
            {materialIconNames.map((iconName) => (
              <li key={`icon--${iconName}`}>
                <Icon name={iconName} flair="outlined" />
                {iconName}
              </li>
            ))}
          </ul>

          <h3>Custom icons</h3>
          <ul className="DesignSystem__icons">
            {customIconNames.map((iconName) => (
              <li key={`icon--${iconName}`}>
                <Icon name={iconName} />
                {iconName}
              </li>
            ))}
          </ul>
        </Container>
      </div>
    </article>
  );
};

export default DesignSystem;
